// src/components/FontFamilyControl.jsx
import React from 'react'
import { EditorState, RichUtils, Modifier } from 'draft-js'
import { STYLE_MAP } from './editorToolbar'

// Opciones visibles en el select (elige tus favoritas)
const FONT_OPTIONS = [
  { label: 'Inter', style: 'FONTFAMILY-Inter' },
  { label: 'System UI', style: 'FONTFAMILY-SystemUI' },
  { label: 'Roboto', style: 'FONTFAMILY-Roboto' },
  { label: 'Open Sans', style: 'FONTFAMILY-OpenSans' },
  { label: 'DM Sans', style: 'FONTFAMILY-DMSans' },
  { label: 'Poppins', style: 'FONTFAMILY-Poppins' },
  { label: 'Montserrat', style: 'FONTFAMILY-Montserrat' },
  { label: 'Lato', style: 'FONTFAMILY-Lato' },
  { label: 'Nunito', style: 'FONTFAMILY-Nunito' },
  { label: 'Raleway', style: 'FONTFAMILY-Raleway' },
  { label: 'Work Sans', style: 'FONTFAMILY-WorkSans' },
  { label: 'Space Grotesk', style: 'FONTFAMILY-SpaceGrotesk' },
  { label: 'Rubik', style: 'FONTFAMILY-Rubik' },

  { label: 'Georgia', style: 'FONTFAMILY-Georgia' },
  { label: 'Times New Roman', style: 'FONTFAMILY-TimesNewRoman' },
  { label: 'Merriweather', style: 'FONTFAMILY-Merriweather' },
  { label: 'Playfair Display', style: 'FONTFAMILY-Playfair' },
  { label: 'Libre Baskerville', style: 'FONTFAMILY-LibreBaskerville' },
  { label: 'Noto Serif', style: 'FONTFAMILY-NotoSerif' },

  { label: 'Noto Sans', style: 'FONTFAMILY-NotoSans' },
  { label: 'Oswald', style: 'FONTFAMILY-Oswald' },

  { label: 'JetBrains Mono', style: 'FONTFAMILY-JetBrainsMono' },
  { label: 'Fira Code', style: 'FONTFAMILY-FiraCode' },
  { label: 'Mono', style: 'FONTFAMILY-Mono' },
]

// borrar todas las fuentes del rango seleccionado
function clearFontStylesInRange(editorState) {
  const sel = editorState.getSelection()
  let content = editorState.getCurrentContent()
  Object.keys(STYLE_MAP)
    .filter(k => k.startsWith('FONTFAMILY-'))
    .forEach(k => { content = Modifier.removeInlineStyle(content, sel, k) })
  return EditorState.push(editorState, content, 'change-inline-style')
}

// borrar fuentes del override (caret)
function clearFontStylesInOverride(overrideSet) {
  let next = overrideSet
  Object.keys(STYLE_MAP)
    .filter(k => k.startsWith('FONTFAMILY-'))
    .forEach(k => { next = next.remove(k) })
  return next
}

export default function FontFamilyControl({ editorState, setEditorState, setActiveFont, className = '' }) {
  const onChange = (e) => {
    const style = e.target.value
    if (!style) return

    let next = editorState
    const sel = next.getSelection()

    if (sel.isCollapsed()) {
      let override = next.getCurrentInlineStyle()
      override = clearFontStylesInOverride(override).add(style)
      next = EditorState.setInlineStyleOverride(next, override)
      next = EditorState.forceSelection(next, sel)
    } else {
      next = clearFontStylesInRange(next)
      next = RichUtils.toggleInlineStyle(next, style)
      let override = next.getCurrentInlineStyle()
      override = clearFontStylesInOverride(override).add(style)
      next = EditorState.setInlineStyleOverride(next, override)
      next = EditorState.forceSelection(next, next.getSelection())
    }

    setActiveFont?.(style)
    setEditorState(next)
  }

  return (
    <div className={`fontfamily-ctrl ${className}`}>
      <select
        className="fontfamily-ctrl__select"
        aria-label="Fuente"
        defaultValue=""
        onChange={onChange}
      >
        <option value="" disabled>Fuente</option>
        {FONT_OPTIONS.map(opt => (
          <option key={opt.style} value={opt.style}>{opt.label}</option>
        ))}
      </select>
    </div>
  )
}
